// extracted by mini-css-extract-plugin
module.exports = {"defaultLogo":"PaymentLogo_defaultLogo__e02pl","defaultStyle":"PaymentLogo_defaultStyle___1AYu","rounded":"PaymentLogo_rounded__4PJ7Q"};